import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity, Calendar, ClipboardList, Dumbbell, Flame, Star, Users } from "lucide-react";

// Trainer analytics: activity chart, KPIs, rating breakdown.
const AnalyticsTab = ({
  analytics,
  ratingSummary,
}) => {
  return (
    <div className="analytics-view">
      <div className="view-header">
        <h1>Analityka</h1>
      </div>

      <div className="analytics-stats-grid">
        <Card className="stat-card">
          <CardContent>
            <Users size={24} />
            <div className="stat-info">
              <span className="stat-value">{analytics.total_clients}</span>
              <span className="stat-label">Klienci</span>
            </div>
          </CardContent>
        </Card>
        <Card className="stat-card accent">
          <CardContent>
            <Activity size={24} />
            <div className="stat-info">
              <span className="stat-value">{analytics.activity_rate}%</span>
              <span className="stat-label">Aktywność (7d)</span>
            </div>
          </CardContent>
        </Card>
        <Card className="stat-card">
          <CardContent>
            <Dumbbell size={24} />
            <div className="stat-info">
              <span className="stat-value">{analytics.workouts_week}</span>
              <span className="stat-label">Treningi (tydzień)</span>
            </div>
          </CardContent>
        </Card>
        <Card className="stat-card">
          <CardContent>
            <Flame size={24} />
            <div className="stat-info">
              <span className="stat-value">{analytics.workouts_month}</span>
              <span className="stat-label">Treningi (miesiąc)</span>
            </div>
          </CardContent>
        </Card>
        <Card className="stat-card">
          <CardContent>
            <Calendar size={24} />
            <div className="stat-info">
              <span className="stat-value">{analytics.sessions_completed}/{analytics.sessions_month}</span>
              <span className="stat-label">Sesje (miesiąc)</span>
            </div>
          </CardContent>
        </Card>
        <Card className="stat-card">
          <CardContent>
            <ClipboardList size={24} />
            <div className="stat-info">
              <span className="stat-value">{analytics.form_responses}</span>
              <span className="stat-label">Odpowiedzi (30d)</span>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Ratings Summary */}
      <Card style={{marginBottom:16}}>
        <CardHeader>
          <CardTitle style={{fontSize:16}}><Star size={18} /> Oceny sesji</CardTitle>
        </CardHeader>
        <CardContent>
          {ratingSummary ? (
            <div style={{display:'flex', alignItems:'center', gap:24}}>
              <div style={{textAlign:'center'}}>
                <div style={{fontSize:36, fontWeight:700}}>{ratingSummary.average || 0}</div>
                <div style={{fontSize:12, color:'var(--text-secondary)'}}>śr. ocena</div>
                <div style={{fontSize:12, color:'var(--text-secondary)'}}>{ratingSummary.count} ocen</div>
              </div>
              <div style={{flex:1}}>
                {[5,4,3,2,1].map(s => {
                  const count = ratingSummary.distribution?.[s] || 0;
                  const pct = ratingSummary.count > 0 ? (count / ratingSummary.count * 100) : 0;
                  return (
                    <div key={s} style={{display:'flex', alignItems:'center', gap:8, marginBottom:4}}>
                      <span style={{fontSize:12, width:16}}>{s}★</span>
                      <div style={{flex:1, height:8, background:'var(--bg-secondary)', borderRadius:4, overflow:'hidden'}}>
                        <div style={{width:`${pct}%`, height:'100%', background: s >= 4 ? 'var(--success)' : s === 3 ? 'var(--warning)' : 'var(--destructive)', borderRadius:4, transition:'width 0.3s'}} />
                      </div>
                      <span style={{fontSize:11, color:'var(--text-secondary)', width:20, textAlign:'right'}}>{count}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <p style={{fontSize:13, color:'var(--text-secondary)'}}>Brak ocen — klienci mogą oceniać zakończone sesje</p>
          )}
        </CardContent>
      </Card>

      <Card className="analytics-chart-card">
        <CardHeader>
          <CardTitle>Aktywnosc treningowa (14 dni)</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="bar-chart">
            {analytics.daily_activity.map((d, i) => {
              const maxCount = Math.max(...analytics.daily_activity.map(x => x.count), 1);
              return (
                <div key={i} className="bar-col">
                  <div className="bar" style={{ height: `${(d.count / maxCount) * 100}%` }}>
                    {d.count > 0 && <span className="bar-value">{d.count}</span>}
                  </div>
                  <span className="bar-label">{d.date}</span>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>

    </div>
  );
};

export default AnalyticsTab;
